var React = require('react');

function IconPlusRoundInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9.10864","cy":"9.10254","r":"8.5","stroke":"#212121","key":0}),React.createElement("path",{"d":"M9.10864 6.10254V12.1025","stroke":"black","key":1}),React.createElement("path",{"d":"M12.1086 8.8916H6.10864","stroke":"black","key":2})]);
}

IconPlusRoundInline.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = IconPlusRoundInline;

IconPlusRoundInline.default = IconPlusRoundInline;
